import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Button from '../ui/Button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Courses', href: '#courses' },
    { name: 'Classes 5–8', href: '#junior' },
    { name: 'Classes 9–12', href: '#senior' },
    { name: 'AI Programs', href: '#ai' },
  ];

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled 
          ? 'bg-[#0a0a0a]/80 backdrop-blur-xl border-b border-white/5 py-3' 
          : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a href="#" className="text-2xl font-bold tracking-tight text-white group drop-shadow-md">
          Learn<span className="text-cyan-400 group-hover:underline decoration-cyan-400 underline-offset-4 decoration-2">Animated</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a 
              key={link.name} 
              href={link.href} 
              className={`text-sm font-medium transition-colors ${
                isScrolled ? 'text-slate-300 hover:text-cyan-400' : 'text-slate-200 hover:text-white'
              }`}
            >
              {link.name}
            </a>
          ))}
          <Button variant="outlineSmall" className={!isScrolled ? "backdrop-blur-sm bg-white/5 border-white/20 text-white" : ""}>
            Portal Login
          </Button>
        </nav>
        
        {/* Mobile Menu Button Placeholder */}
        <button className="md:hidden text-white">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
        </button>
      </div>
    </motion.header>
  );
};

export default Header;